


























































import { MedTransGoConstants } from '@/util/constants';
import { Component, Vue } from 'vue-property-decorator';
import { required, minLength, email, integer } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';
import { ApiRequest } from '@/types/request';
import { ObjectFactory } from '@/config/objectFactory';
import { CommonUtils } from '@/util/commonUtils';

@Component({
    mixins: [validationMixin],
    props: {
        organizationId: {
            type: String,
            required: true,
        },
        updateBillingContact: {
            type: Boolean,
            default: false,
        },
        existingBillingContact: {
            type: Object,
            required: false,
        },
    },
    data() {
        return {
            name: '',
            email: '',
            phone: '',
            title: '',
        };
    },
    validations() {
        const rules = {
            name: {
                required,
                regex: (fullName: string) => /^[a-zA-Z ]+$/.test(fullName),
            },
            email: {
                required,
                email,
            },
            phone: {
                minLength: minLength(10),
            },
        };
        return rules;
    },
})
export default class AddBillingContactsModal extends Vue {
    private show = true;

    private close() {
        this.$emit('close');
    }

    private mounted() {
        if (this.$props.existingBillingContact) {
            this.$data.name = this.$props.existingBillingContact.name;
            this.$data.title = this.$props.existingBillingContact.title;
            this.$data.email = this.$props.existingBillingContact.email;
            this.$data.phone = this.$props.existingBillingContact.phone;
        }
    }

    private async addBillingContact() {
        const iHttpService = ObjectFactory.getHttpService();
        const organizationId = this.$props.organizationId;
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_ORGANIZATIONS}/${organizationId}/billingContact`,
            data: {
                billingContact: {
                    name: this.$data.name,
                    title: this.$data.title,
                    email: this.$data.email,
                    phone: this.$data.phone,
                },
            },
            loaderEvent: {
                show: true,
            },
        };
        await iHttpService.put<any>(apiRequest);
        this.close();
        this.$emit('billingContactAdded');
    }

    private maskPhone(phone: string) {
        return CommonUtils.phoneNumberMask(phone);
    }
}

